import React from 'react';
import { Stack } from '@mui/material';

function Offers() {
  return (
    <Stack>Hizmetlerimiz</Stack>
  )
}

export default Offers